export var GET_ALL_FREELANCERS = '[Freelancers] Get All';
export var GET_FREELANCER = '[Freelancers] Get Freelancer';
export var GET_ALL_FREELANCERS_SUCCESS = '[Freelancers] Get All Success';
export var GET_ALL_FREELANCERS_ERROR = '[Freelancers] Get All Error';
export var GET_FREELANCER_SUCCESS = '[Freelancers] Get Freelancer Success';
export var GET_FREELANCER_ERROR = '[Freelancers] Get Freelancer Error';
export var ADD_FREELANCER = '[Freelancer] Add';
export var ADD_FREELANCER_SUCCESS = '[Freelancer] Add Success';
export var ADD_FREELANCER_ERROR = '[Freelancer] Add Error';
export var UPDATE_FREELANCER = '[Freelancer] Update';
export var UPDATE_FREELANCER_SUCCESS = '[Freelancer] Update Success';
export var UPDATE_FREELANCER_ERROR = '[Freelancer] Update Error';
export var DELETE_FREELANCER = '[Freelancer] Delete';
export var DELETE_FREELANCER_SUCCESS = '[Freelancer] Delete Success';
export var DELETE_FREELANCER_ERROR = '[Freelancer] Delete Error';
var GetAllFreelancers = /** @class */ (function () {
    function GetAllFreelancers() {
        this.type = GET_ALL_FREELANCERS;
    }
    return GetAllFreelancers;
}());
export { GetAllFreelancers };
var GetAllFreelancersSuccess = /** @class */ (function () {
    function GetAllFreelancersSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_FREELANCERS_SUCCESS;
    }
    return GetAllFreelancersSuccess;
}());
export { GetAllFreelancersSuccess };
var GetAllFreelancersError = /** @class */ (function () {
    function GetAllFreelancersError(payload) {
        this.payload = payload;
        this.type = GET_ALL_FREELANCERS_ERROR;
    }
    return GetAllFreelancersError;
}());
export { GetAllFreelancersError };
var GetFreelancer = /** @class */ (function () {
    function GetFreelancer(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER;
    }
    return GetFreelancer;
}());
export { GetFreelancer };
var GetFreelancerSuccess = /** @class */ (function () {
    function GetFreelancerSuccess(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_SUCCESS;
    }
    return GetFreelancerSuccess;
}());
export { GetFreelancerSuccess };
var GetFreelancerError = /** @class */ (function () {
    function GetFreelancerError(payload) {
        this.payload = payload;
        this.type = GET_FREELANCER_ERROR;
    }
    return GetFreelancerError;
}());
export { GetFreelancerError };
var AddFreelancer = /** @class */ (function () {
    function AddFreelancer(payload) {
        this.payload = payload;
        this.type = ADD_FREELANCER;
    }
    return AddFreelancer;
}());
export { AddFreelancer };
var AddFreelancerSuccess = /** @class */ (function () {
    function AddFreelancerSuccess(payload) {
        this.payload = payload;
        this.type = ADD_FREELANCER_SUCCESS;
    }
    return AddFreelancerSuccess;
}());
export { AddFreelancerSuccess };
var AddFreelancerError = /** @class */ (function () {
    function AddFreelancerError(payload) {
        this.payload = payload;
        this.type = ADD_FREELANCER_ERROR;
    }
    return AddFreelancerError;
}());
export { AddFreelancerError };
var UpdateFreelancer = /** @class */ (function () {
    function UpdateFreelancer(payload) {
        this.payload = payload;
        this.type = UPDATE_FREELANCER;
    }
    return UpdateFreelancer;
}());
export { UpdateFreelancer };
var UpdateFreelancerSuccess = /** @class */ (function () {
    function UpdateFreelancerSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_FREELANCER_SUCCESS;
    }
    return UpdateFreelancerSuccess;
}());
export { UpdateFreelancerSuccess };
var UpdateFreelancerError = /** @class */ (function () {
    function UpdateFreelancerError(payload) {
        this.payload = payload;
        this.type = UPDATE_FREELANCER_ERROR;
    }
    return UpdateFreelancerError;
}());
export { UpdateFreelancerError };
var DeleteFreelancer = /** @class */ (function () {
    function DeleteFreelancer(payload) {
        this.payload = payload;
        this.type = DELETE_FREELANCER;
    }
    return DeleteFreelancer;
}());
export { DeleteFreelancer };
var DeleteFreelancerSuccess = /** @class */ (function () {
    function DeleteFreelancerSuccess(payload) {
        this.payload = payload;
        this.type = DELETE_FREELANCER_SUCCESS;
    }
    return DeleteFreelancerSuccess;
}());
export { DeleteFreelancerSuccess };
var DeleteFreelancerError = /** @class */ (function () {
    function DeleteFreelancerError(payload) {
        this.payload = payload;
        this.type = DELETE_FREELANCER_ERROR;
    }
    return DeleteFreelancerError;
}());
export { DeleteFreelancerError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/actions/freelancer.action.ts.pre-build-optimizer.js